import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import ProductStockList, { ProductStockItem } from '../Components/ProductStockList';
import {
  useGetSTMProductsQuery,
  useUpdateSTMProductImageMutation,
} from '../redux/services/stmproductApi';

const STProducts = ({ navigation }: any) => {
  const cid = useSelector((state: RootState) => state.gdata.company);
  const { data: products = [], isLoading, refetch } = useGetSTMProductsQuery(cid, { skip: !cid });
  const [updateImage] = useUpdateSTMProductImageMutation();

  const items = useMemo<ProductStockItem[]>(
    () =>
      (Array.isArray(products) ? products : []).map((p: any) => ({
        id: Number(p.pr_id),
        name: p.pr_name,
        code: p.pr_code || '',
        uom: String(p.pr_uom || ''),
        stock: Number(p.pr_stock ?? 0),
        minStock: Number(p.pr_minstock || 0),
        image: p.pr_image || '',
      })),
    [products],
  );

  return (
    <ProductStockList
      title="Store Products"
      items={items}
      isLoading={isLoading}
      onRefresh={() => refetch()}
      saveImage={(id, key) => updateImage({ pr_id: id, pr_image: key }).unwrap()}
      onBack={() => navigation?.goBack?.()}
    />
  );
};

export default STProducts;
